
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal, Eye, Edit, Package, Truck, CheckCircle, XCircle } from "lucide-react";

interface OrderActionButtonsProps {
  orderId: string;
  currentStatus: string;
  onViewOrder: (orderId: string) => void;
  onUpdateStatus: (orderId: string, status: string) => void;
}

const OrderActionButtons = ({ 
  orderId, 
  currentStatus, 
  onViewOrder, 
  onUpdateStatus 
}: OrderActionButtonsProps) => {
  const statusActions = [
    { 
      status: 'processing', 
      label: 'Mark as Processing', 
      icon: Edit,
      disabled: currentStatus === 'processing' || currentStatus === 'shipped' || currentStatus === 'delivered'
    },
    { 
      status: 'shipped', 
      label: 'Mark as Shipped', 
      icon: Truck,
      disabled: currentStatus !== 'processing'
    },
    { 
      status: 'delivered', 
      label: 'Mark as Delivered', 
      icon: CheckCircle,
      disabled: currentStatus !== 'shipped'
    },
    { 
      status: 'cancelled', 
      label: 'Cancel Order', 
      icon: XCircle,
      disabled: currentStatus === 'delivered' || currentStatus === 'cancelled'
    },
  ];

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onViewOrder(orderId)}
        className="text-admin-muted-foreground hover:text-admin-foreground"
      >
        <Eye className="h-4 w-4" />
      </Button>
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {statusActions.map((action) => {
            const Icon = action.icon;
            return (
              <DropdownMenuItem
                key={action.status}
                onClick={() => onUpdateStatus(orderId, action.status)}
                disabled={action.disabled}
                className="flex items-center gap-2"
              >
                <Icon className="h-4 w-4" />
                {action.label}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default OrderActionButtons;
